import { render, staticRenderFns } from "./baleSingleSku.vue?vue&type=template&id=a96ad9c0&scoped=true&"
import script from "./baleSingleSku.vue?vue&type=script&lang=js&"
export * from "./baleSingleSku.vue?vue&type=script&lang=js&"
import style0 from "./baleSingleSku.vue?vue&type=style&index=0&id=a96ad9c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96ad9c0",
  null
  
)

export default component.exports